var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMapVisited(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 52,
    viewBox: "0 0 44 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_1250_6885)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.75 18C38.75 23.5175 35.7162 28.8285 32.0396 33.2103C28.3857 37.5649 24.2439 40.8273 22.3401 42.2261C22.1299 42.3806 21.8701 42.3806 21.6599 42.2261C19.7561 40.8273 15.6143 37.5649 11.9604 33.2102C8.28381 28.8285 5.25 23.5175 5.25 18C5.25 13.5576 7.01473 9.29719 10.156 6.15596C13.2972 3.01473 17.5576 1.25 22 1.25C26.4424 1.25 30.7028 3.01473 33.844 6.15596C36.9853 9.29719 38.75 13.5576 38.75 18Z",
    fill: "#E65402",
    stroke: "#FFFEF9",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9898 23.2854C30.9898 24.7172 30.9664 26.1509 30.9996 27.5827C31.0152 28.261 30.5804 28.6734 29.9487 28.6387C29.436 28.6098 28.9193 28.6387 28.4066 28.633C27.7768 28.6272 27.5117 28.4537 27.3869 27.8467C27.2368 27.1298 26.3984 26.8928 25.8681 27.3707C24.478 28.6214 22.7955 29.0511 20.9491 28.9952C19.5259 28.9509 18.1689 28.6599 16.9017 28.0163C14.8331 26.9641 13.4469 25.3107 12.708 23.1485C11.7663 20.3909 11.7526 17.6025 12.7353 14.8583C13.8271 11.8059 16.0653 9.98093 19.2393 9.29489C21.3625 8.83625 23.4876 8.88057 25.5425 9.65525C28.0907 10.613 29.6972 12.4533 30.5141 14.9951C30.7325 15.6735 30.3367 16.1976 29.6075 16.2053C28.3754 16.2188 27.1451 16.2111 25.913 16.2073C25.4782 16.2073 25.1721 16.0068 25.0064 15.606C25.0005 15.5925 24.9966 15.5771 24.9908 15.5636C24.4332 14.313 23.5344 13.5017 22.0955 13.4265C20.5202 13.3456 19.2608 13.9006 18.436 15.2746C17.9662 16.0569 17.7459 16.9203 17.6562 17.8164C17.5158 19.1904 17.5646 20.5528 17.9779 21.8863C18.1007 22.2852 18.2645 22.6668 18.4809 23.0252C19.2237 24.2585 20.3272 24.8578 21.7758 24.8424C22.31 24.8366 22.8286 24.7461 23.3199 24.5264C24.6047 23.9521 25.1155 22.7785 25.1311 21.5876C25.1331 21.3911 25.0298 21.3641 24.8679 21.366C24.3064 21.3699 23.7449 21.366 23.1854 21.366C23.0606 21.366 22.9358 21.3737 22.8111 21.3621C22.3237 21.3159 22.002 21.0076 21.9844 20.522C21.961 19.9381 21.961 19.3503 21.9805 18.7664C21.9981 18.2114 22.3392 17.8934 22.9046 17.8799C23.3258 17.8684 23.7469 17.878 24.168 17.878C26.0221 17.878 27.8782 17.878 29.7323 17.878C29.8259 17.878 29.9195 17.878 30.0131 17.878C30.6565 17.8915 30.9918 18.2133 30.9937 18.8512C30.9996 20.3292 30.9937 21.8092 30.9937 23.2873L30.9898 23.2854Z",
    fill: "#FFFEF9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_1250_6885",
    x: 0,
    y: 0,
    width: 44,
    height: 51.592,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1250_6885"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1250_6885",
    result: "effect2_dropShadow_1250_6885"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1250_6885",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapVisited);
export default __webpack_public_path__ + "static/media/map_visited.55e5f67f54b28e4917212128b5730038.svg";
export { ForwardRef as ReactComponent };